<template>
    <div v-html="svgContent"></div>
</template>

<script>
import axios from 'axios';
export default {
name: "Plan_svg",
  data() {
    return {
      svgContent: ''
    };
  },
  mounted() {
    this.loadSvg();
  },
  methods: {
    async loadSvg() {
      try {
        const response = await axios.get(require('../../assets/plan.svg'));
        this.svgContent = response.data;
      } catch (error) {
        console.error('Error loading SVG:', error);
      }
    }
  }
};
</script>

<style scoped>


</style>
